import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import React from "react"; // optional
import UserInfoModal from "Components/Modal/UserInfoModal/UserInfoModal";
import { HiOutlineDotsCircleHorizontal } from "react-icons/hi";
import { Link } from "react-router-dom";
import TextLimit from 'Api/TextLimit';

function AbsentCell({ getValue }) {
    const value = getValue();
    let text = " ";
    let longText = "";
    var id = 0;
    var substitutionId = 0;
    var status = "";

    if (value && value.length !== 0) {
        if (value.length > 1) {
            text = "Multiple";
        }

        if (value.length === 1) {
            longText = value[0].vFirstName + " " + value[0].vLastName;
            text = value[0].vFirstName + " " + (value[0].vLastName ? value[0].vLastName.charAt(0) : "");
            id = value[0].iSubstitutorAdminId;
            substitutionId = value[0].iSubstitutionId;
            status = value[0].eSubStatus;
        }
    }
    return (
         <Tippy
            content={
                longText === 'X null' || id === 0 || status === 'Aangevraagd' || status === 'Geannuleerd'
                    ? 'Openstaand'
                    : status === 'Voorlopig'
                        ? 'Voorlopig ingepland'
                        : longText
            }
            placement="bottom"
            arrow
            className="custom-tooltip"
        >
            {
                status === 'Voorlopig' ? (
                    <span>Voorlopig ingepland</span>

                ) : (
                    (status === 'Aangevraagd' || status === 'Geannuleerd') && substitutionId > 0 ? (
                        <span><HiOutlineDotsCircleHorizontal fontSize={24} /></span>
                    ) : (
                        <span><UserInfoModal id={id} name={text} substitutionId={substitutionId} /></span>
                    )
                )
            }

        </Tippy>
    );

}

function AfwezigeCell({ value }) {
    return <Tippy content={value} placement="bottom"><a href="/verzoeken/">{value}</a></Tippy>
}

export function convertHeaders(tableHeaders) {
    let formattedHeaders = tableHeaders.map((n, index) => {
        const dayKey = n.day.toLowerCase();

        return {
            header: () => n.date,
            id: String(index + 1),
            columns: [
                {
                    header: "Ochtend",
                    id: `${dayKey}_ochtend`,
                    accessorKey: `${dayKey}_ochtend`,
                    cell: AbsentCell,
                },
                {
                    header: "Middag",
                    id: `${dayKey}_middag`,
                    accessorKey: `${dayKey}_middag`,
                    cell: AbsentCell,
                }
            ]
        };
    });

    formattedHeaders.unshift({
        header: ' ',
        id: '0',
        columns: [
            {
                header: 'Afwezige',
                id: 'afwezige',
                accessorFn: value => value,
                cell: ({ row }) => {
                    const value = row.original;
                    const fullName = window.innerWidth > 1250
                        ? TextLimit.AfwezigeLimitOptionOne(value.vFirstName, value.vMiddleName, value.vLastName)
                        : TextLimit.AfwezigeLimitOptionTwo(value.vFirstName, value.vMiddleName, value.vLastName);

                    return (
                        <Link to={`/verzoeken/${value.iSubstitutionId}`}>
                            {fullName.trim() === '' ? '---' : fullName}
                        </Link>
                    );
                }
            },
            {
                header: 'Code',
                id: 'code',
                accessorFn: value => value,
                cell: ({ row }) => {
                    const value = row.original;
                    const codeText = value.code !== undefined ? value.code : '';
                    return TextLimit.codeLimitOptionOne(codeText);
                }
            },
            {
                header: 'School',
                id: 'school',
                accessorFn: value => value,
                cell: ({ row }) => {
                    const value = row.original;
                    return window.innerWidth > 1250
                        ? TextLimit.limitStringLargeScreen(value.school)
                        : TextLimit.limitStringSmallScreen(value.school);
                }
            }
        ]
    });

    return formattedHeaders;
}